const action = require('../action/action');

const confirm = Object.assign({}, action, {
    modal: false,
    confirmMessage: '',
    consequence: false,

    init: function () {
        action.init.call(this);
        this.confirmMessage = this.extraAttributes.confirmMessage;
    },

    act: function () {
        this.modal = this.hm.newComponent('modal');
        this.modal.init();
        this.modal.setContent(this.confirmMessage);

        let okButtonHTML = '<button class="' + this.hm.app.cssClass('primaryButton') + '">' + this.hm.app.utext('ok') + '</button>';
        let okButton = this.hm.helper.string2element(okButtonHTML);
        okButton.onclick = (event) => {
            this.confirmed();
        };

        this.modal.element.addEventListener('hidden.bs.modal', (event) => {
            this.removeModal();
        })

        this.modal.addAction(okButton);
        this.modal.open();
    },

    confirmed: function () {
        this.removeModal();
        if (this.consequence === false) {
            action.act.call(this);
        } else {
            this.consequence.call();
        }
    },

    removeModal: function () {
        this.modal.dispose();
        this.modal = false;
    }
});

module.exports = confirm;